<script>
import { isEmpty } from 'lodash'
import api from '@/helpers/api'
export default {
  name: 'product-selector-dialog',
  components: {},
  props: {
    value: { type: String },
    visible: { type: Boolean, default: false },
    closeOnSelect: { type: Boolean, default: false },
    customFilter: { type: Array }
  },
  data: () => ({
    categories: [],
    products: [],
    category: {},
    crumbs: [],
    level: 0
  }),
  watch: {
    value: {
      handler: 'init',
      immediate: true
    }
  },
  async mounted () {
    this.init()
  },
  methods: {
    isEmpty,
    async loadData (parentCategory = null) {
      let filters = []
      let productFilters = []
      if (!isEmpty(parentCategory)) {
        this.category = { ...parentCategory }
        filters = [{ parent_category_id: { _eq: parentCategory.id } }]
        productFilters = [{ category_id: { _eq: parentCategory.id } }]
      } else {
        filters = [{ parent_category_id: { _is_null: true } }]
        productFilters = [{ category_id: { _is_null: true } }]
        this.category = {}
        this.level = 0
        this.crumbs = []
      }
      let { items: categories } = await api.productCategories.fetchPage({
        page: 1,
        pageSize: -1,
        filters
      })

      if (this.customFilter)
        productFilters = [...productFilters, ...this.customFilter]

      let { items: products } = await api.items.fetchPage({
        page: 1,
        pageSize: -1,
        filters: [...productFilters, { is_discontinued: { _eq: false } }]
      })

      this.categories = [...categories]
      this.products = [
        ...products.map(p => ({
          ...p,
          stock_color: p.is_stock_item
            ? p.stock_level <= 0
              ? 'danger'
              : p.stock_level < p.reorder_stock_level
              ? 'warning'
              : 'success'
            : 'dark'
        }))
      ]
    },
    async init () {
      if (this.value) {
        let item = await api.productCategories.fetch({
          id: this.value
        })
        this.loadData(item)
      } else {
        this.loadData({})
      }
    },
    onCancel (bvModalEvt) {
      this.$refs['__product_selector_modal__'].hide()
    },

    onLevelUp () {
      this.level = this.level - 1
      this.crumbs.length = this.level
      this.loadData(this.category.parent_category)
    },
    onLevelDown (category) {
      this.level = this.level + 1
      this.crumbs.push(category)
      this.loadData(category)
    },
    onGoToLevel (level, category) {
      this.level = level
      this.crumbs.length = level
      this.loadData(category)
    },
    onClear () {
      this.$emit('input', null)
    },
    selectProduct (p) {
      this.$emit('input', p)
      this.$emit('update:visible', false)
      if (this.closeOnSelect) this.onCancel()
    },
    onProductHovered (product, hovered) {
      product = {
        ...product,
        hovered
      }
    }
  },
  computed: {
    selectedCategoryName () {
      return this.category.name || '- Click to Select a Category -'
    },
    saveBtnLabel () {
      return !isEmpty(this.category)
        ? `Select ${this.category.name}`
        : 'Nothing Selected'
    },
    breadCrumbs () {
      if (isEmpty(this.category)) return []
      return [
        {
          text: this.category.name,
          active: true
        }
      ]
    }
  }
}
</script>
<template>
  <b-modal
    ref="__product_selector_modal__"
    size="xl"
    :style="{ minHeight: '40vh' }"
    hide-header
    v-bind="$attrs"
    v-on="$listeners"
  >
    <b-breadcrumb class="bg-transparent">
      <b-breadcrumb-item v-on:click="onGoToLevel(0, null)">
        <i class="bx bxs-home mr-2"></i>TOP
      </b-breadcrumb-item>
      <template v-for="(c, idx) in crumbs">
        <b-breadcrumb-item
          :key="c.id"
          v-on:click="onGoToLevel(idx + 1, c)"
          v-if="idx + 1 < crumbs.length"
          >{{ c.name }}</b-breadcrumb-item
        >
        <b-breadcrumb-item :key="c.id" active v-else>{{
          c.name
        }}</b-breadcrumb-item>
      </template>
    </b-breadcrumb>

    <h4 class="card-title" v-if="!isEmpty(categories)">Categories</h4>
    <div
      class="d-flex justify-content-start flex-wrap mb-4"
      v-if="!isEmpty(categories)"
    >
      <b-btn
        @click="onLevelUp"
        variant="outline-primary"
        size="lg"
        :squared="true"
        class="m-1 py-2"
        :disabled="isEmpty(category)"
        v-if="false"
      >
        <i class="fas fa-arrow-circle-up mr-2"></i>Up
      </b-btn>
      <template v-if="!isEmpty(categories)">
        <b-btn
          v-for="cat in categories"
          :key="cat.id"
          v-on:click="onLevelDown(cat)"
          variant="outline-primary"
          size="lg"
          :squared="true"
          class="m-1 p-4"
          :style="{ minWidth: '140px' }"
          >{{ cat.name }}</b-btn
        >
      </template>
    </div>
    <h4 class="card-title">Products</h4>
    <div
      class="d-flex justify-content-start flex-wrap"
      v-if="!isEmpty(products)"
    >
      <b-card
        header-class="bg-transparent border-primary text-dark rounded-0 p-2"
        class="border border-primary m-1 pointer hover-sm rounded-0"
        :header="product.code"
        v-for="product in products"
        :key="product.id"
        v-on:click="selectProduct(product)"
        align="center"
        :style="{ minWidth: '150px' }"
      >
        <template v-slot:header>
          <div class="d-flex justify-content-between">
            <div>{{ product.code }}</div>
            <div v-if="product.is_stock_item">
              <i
                class="bx bxs-circle mr-2"
                :class="`text-${product.stock_color}`"
              ></i>
              <span
                >{{ product.stock_level }}/{{
                  product.default_stock_level
                }}</span
              >
            </div>
          </div>
        </template>
        <b-card-text class="text-truncate" :style="{ width: '150px' }">{{
          product.short_description
        }}</b-card-text>
      </b-card>
    </div>
    <div v-else class="text-center p-4">No Products</div>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-btn variant="outline-primary" @click="onCancel" class="mr-2"
            >Close</b-btn
          >
        </div>
      </div>
    </template>
  </b-modal>
</template>
